export default "<h1>F.A.Q.</h1>\r\n";